import React from "react";
import WorkCard from "./WorkCard";
import useFetch from "../../../hooks/useFetch";
import { useState } from "react";
import { useEffect } from "react";
import { apiPath } from "../../../utility/Constant";
import useSession from "../../../hooks/useSession";
import Loading from "../../../components/shared/loading/Loading";

function WorkListPage() {
  const { CSRApi } = apiPath;
  const [user, loading] = useSession();
  const [csrData, uloading] = useFetch(CSRApi, true);
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    const filtereddata = [...csrData].filter((item) => item.slug === "work");
    setFilteredData(filtereddata);
  }, [csrData]);

  if (uloading) {
    return <Loading />;
  }

  return (
    <div>
      {/* focus list */}
      <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
        <h2 className="font-medium text-2xl mb-4">Work List</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <WorkCard />
          {filteredData?.map((project, index) => (
            <WorkCard key={index} project={project} user={user.role} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default WorkListPage;
